/* TrenBee Reviews - write-a-review drawer. Rail + photo viewer: tb-reviews-rail.js. No credentials here.
   Deep link: ?write_review=1 opens the drawer (review emails); optional &tb_o=<order id> lets the Worker
   check that exact order for the Verified Buyer badge. Reward code is revealed after ANY successful submission. */
(() => {
function tbrInit(root) {
  if (!root || root.dataset.tbrReady) return;
  root.dataset.tbrReady = '1';

  const cfg = {
    proxy: (root.dataset.proxy || '/apps/tb-reviews').replace(/\/+$/, ''),
    siteKey: root.dataset.siteKey || '',
    productId: root.dataset.productId,
  };
  const ALLOWED = { 'image/jpeg': ['jpg', 'jpeg'], 'image/png': ['png'], 'image/webp': ['webp'] };
  const MAX_BYTES = 15 * 1024 * 1024, MIN_EDGE = 500;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const WORDS = ['', 'Not for me', 'Could be better', 'Good', 'Loved it', 'Obsessed ♡'];
  const MESSAGES = {
    captcha: 'Please complete the verification check.',
    duplicate: 'You’ve already reviewed this product with this email — thank you!',
    rate_limited: 'Too many attempts. Please wait a minute and try again.',
    photo_type: 'Please choose a JPG, PNG or WEBP photo.',
    photo_size: 'That photo is larger than 15 MB. Please choose a smaller one.',
    photo_small: 'That photo is too small. Please choose one at least 500 px on its shortest side.',
    photo_invalid: 'We couldn’t process that photo. Please try a different one.',
    photo_timeout: 'Your photo is taking too long to process. Please try again.',
    photo_expired: 'Your photo upload expired. Please submit again.',
    upload_failed: 'Your photo couldn’t be uploaded. Check your connection and try again.',
    unavailable: 'Reviews can’t be submitted right now. Please try again later.',
    invalid: 'Please check the highlighted fields.',
  };

  const $ = (s) => root.querySelector(s);

  /* ---------- email deep link ---------- */
  const qs = new URLSearchParams(window.location.search);
  const wantsReview = qs.get('write_review') === '1';
  const linkOrder = (qs.get('tb_o') || '').replace(/\D/g, '').slice(0, 20) || null;
  if (wantsReview || qs.has('tb_o')) {
    // Clean the address bar so a refresh or a shared link doesn't re-open the form or carry the order id.
    qs.delete('write_review'); qs.delete('tb_o');
    const rest = qs.toString();
    try { window.history.replaceState(window.history.state, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash); } catch (_) {}
  }

  /* ---------- drawer ---------- */
  const modal = $('.tbr-modal'), form = $('[data-tbr-form]'), done = $('[data-tbr-done]');
  const stars = [...root.querySelectorAll('.tbr-star')], word = $('[data-tbr-rating-word]');
  const bodyEl = form.elements.body, nameEl = form.elements.name, emailEl = form.elements.email;
  const fileEl = $('[data-tbr-file]'), uploadBox = $('[data-tbr-upload]'), preview = $('[data-tbr-preview]'), previewImg = $('[data-tbr-preview-img]');
  const submitBtn = $('[data-tbr-submit]'), submitLabel = $('[data-tbr-submit-label]');
  let rating = 0, file = null, previewUrl = null, openedAt = 0, captchaToken = null, widgetId = null, lastFocus = null, busy = false;

  const err = (k, msg) => {
    const el = root.querySelector(`[data-tbr-err="${k}"]`); if (!el) return;
    const field = el.closest('.tbr-field');
    if (msg === false) { el.hidden = true; field && field.classList.remove('has-error'); return; }
    if (msg) el.textContent = msg;
    el.hidden = false; field && field.classList.add('has-error');
  };
  const clearErrs = () => root.querySelectorAll('[data-tbr-err]').forEach((e) => { e.hidden = true; const f = e.closest('.tbr-field'); f && f.classList.remove('has-error'); });

  function open() {
    lastFocus = document.activeElement;
    if (!done.hidden) { done.hidden = true; form.hidden = false; form.reset(); setRating(0); resetPhoto(); count.textContent = '0 / 2000'; }
    modal.hidden = false;
    document.documentElement.classList.add('tbr-lock');
    openedAt = Date.now();
    loadCaptcha();
    setTimeout(() => (stars[0] || modal).focus(), 80);
  }
  function close() {
    if (busy) return;
    modal.hidden = true;
    document.documentElement.classList.remove('tbr-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  root.querySelectorAll('[data-tbr-open]').forEach((b) => b.addEventListener('click', open));
  modal.addEventListener('click', (e) => { if (e.target.closest('[data-tbr-close]')) close(); });
  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const f = [...modal.querySelectorAll('button,input,textarea,a[href],[tabindex]:not([tabindex="-1"])')].filter((x) => !x.disabled && x.offsetParent !== null && x.type !== 'file');
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- rating ---------- */
  function paint(v) { stars.forEach((s, i) => s.classList.toggle('is-on', i < v)); }
  function setRating(v) {
    rating = v; paint(v);
    stars.forEach((s, i) => { s.setAttribute('aria-checked', String(i + 1 === v)); s.tabIndex = (i + 1 === (v || 1)) ? 0 : -1; });
    word.textContent = WORDS[v] || '';
    if (v) err('rating', false);
  }
  stars.forEach((s) => {
    s.addEventListener('click', () => setRating(Number(s.dataset.value)));
    s.addEventListener('mouseenter', () => { paint(Number(s.dataset.value)); word.textContent = WORDS[Number(s.dataset.value)]; });
    s.addEventListener('mouseleave', () => setRating(rating));
    s.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); const v = Math.min(5, (rating || 0) + 1); setRating(v); stars[v - 1].focus(); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); const v = Math.max(1, (rating || 2) - 1); setRating(v); stars[v - 1].focus(); }
    });
  });
  setRating(0);

  /* ---------- text / size / email ---------- */
  const count = $('[data-tbr-count]');
  bodyEl.addEventListener('input', () => { count.textContent = bodyEl.value.length + ' / 2000'; if (bodyEl.value.trim().length >= 10) err('body', false); });
  nameEl.addEventListener('input', () => { if (nameEl.value.trim().length >= 2) err('name', false); });
  emailEl.addEventListener('input', () => { const v = emailEl.value.trim(); if (!v || EMAIL_RE.test(v)) err('email', false); });
  root.querySelectorAll('.tbr-chip input').forEach((r) => {
    r.addEventListener('pointerdown', () => { r.dataset.was = r.checked ? '1' : ''; });
    r.addEventListener('click', () => { if (r.dataset.was === '1') { r.checked = false; r.dataset.was = ''; } err('size', false); });
  });

  /* ---------- photo ---------- */
  function resetPhoto() {
    file = null; fileEl.value = '';
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    previewUrl = null; previewImg.removeAttribute('src');
    preview.hidden = true; uploadBox.hidden = false; err('photo', false);
  }
  async function imageSize(f) {
    if ('createImageBitmap' in window) {
      try { const bmp = await createImageBitmap(f); const s = { w: bmp.width, h: bmp.height }; bmp.close && bmp.close(); return s; } catch (_) {}
    }
    return new Promise((res) => { const i = new Image(); const u = URL.createObjectURL(f); i.onload = () => { res({ w: i.naturalWidth, h: i.naturalHeight }); URL.revokeObjectURL(u); }; i.onerror = () => { res(null); URL.revokeObjectURL(u); }; i.src = u; });
  }
  fileEl.addEventListener('change', async () => {
    const f = fileEl.files && fileEl.files[0];
    if (!f) return;
    const ext = (f.name.split('.').pop() || '').toLowerCase();
    if (!ALLOWED[f.type] || !ALLOWED[f.type].includes(ext)) { resetPhoto(); err('photo', MESSAGES.photo_type); return; }
    if (f.size > MAX_BYTES) { resetPhoto(); err('photo', MESSAGES.photo_size); return; }
    const dim = await imageSize(f);
    if (!dim) { resetPhoto(); err('photo', MESSAGES.photo_invalid); return; }
    if (Math.min(dim.w, dim.h) < MIN_EDGE) { resetPhoto(); err('photo', MESSAGES.photo_small); return; }
    file = f;
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    previewUrl = URL.createObjectURL(f);
    previewImg.src = previewUrl;
    uploadBox.hidden = true; preview.hidden = false; err('photo', false);
  });
  $('[data-tbr-change]').addEventListener('click', () => fileEl.click());
  $('[data-tbr-remove]').addEventListener('click', resetPhoto);

  /* ---------- Turnstile (loaded only when the drawer opens) ---------- */
  function loadCaptcha() {
    if (!cfg.siteKey || widgetId !== null) return;
    const render = () => {
      if (widgetId !== null || !window.turnstile) return;
      widgetId = window.turnstile.render($('[data-tbr-captcha]'), {
        sitekey: cfg.siteKey, theme: 'light', size: 'flexible', appearance: 'interaction-only',
        callback: (t) => { captchaToken = t; err('captcha', false); },
        'expired-callback': () => { captchaToken = null; },
        'error-callback': () => { captchaToken = null; },
      });
    };
    if (window.turnstile) return render();
    window.__tbrTurnstileReady = render;
    if (!document.getElementById('tbr-turnstile')) {
      const s = document.createElement('script');
      s.id = 'tbr-turnstile'; s.async = true; s.defer = true;
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=__tbrTurnstileReady';
      document.head.appendChild(s);
    }
  }
  function resetCaptcha() { captchaToken = null; if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId); }

  /* ---------- network ---------- */
  async function fetchWithTimeout(url, options, timeoutMs) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
      return await fetch(url, Object.assign({}, options, { signal: controller.signal }));
    } finally {
      clearTimeout(timer);
    }
  }
  async function api(route, payload) {
    let r;
    try {
      r = await fetchWithTimeout(cfg.proxy + '/' + route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      }, route === 'upload-target' ? 20000 : 30000);
    } catch (e) {
      return { ok: false, error: e && e.name === 'AbortError' ? (route === 'upload-target' ? 'photo_timeout' : 'unavailable') : 'unavailable' };
    }
    const type = r.headers.get('content-type') || '';
    if (!type.includes('application/json')) return { ok: false, error: 'unavailable' };
    try { return await r.json(); } catch (_) { return { ok: false, error: 'unavailable' }; }
  }
  async function uploadPhoto(f) {
    const target = await api('upload-target', { filename: f.name, mimeType: f.type, fileSize: f.size });
    if (!target.ok) return target;
    const staged = target.target;
    if (!staged || !staged.url || !Array.isArray(staged.parameters) || !target.resourceUrl || !target.uploadToken) return { ok: false, error: 'upload_failed' };
    const fd = new FormData();
    staged.parameters.forEach((p) => fd.append(p.name, p.value));
    fd.append('file', f);
    try {
      const r = await fetchWithTimeout(staged.url, {
        method: 'POST',
        body: fd,
        mode: 'cors',
        credentials: 'omit'
      }, 45000); // direct to Shopify storage
      if (!r.ok) return { ok: false, error: 'upload_failed' };
    } catch (e) {
      return { ok: false, error: e && e.name === 'AbortError' ? 'photo_timeout' : 'upload_failed' };
    }
    return { ok: true, uploadToken: target.uploadToken, resourceUrl: target.resourceUrl };
  }

  /* ---------- submit ---------- */
  function validate() {
    clearErrs();
    let ok = true;
    if (!rating) { err('rating'); ok = false; }
    if (bodyEl.value.trim().length < 10) { err('body'); ok = false; }
    if (nameEl.value.trim().length < 2) { err('name'); ok = false; }
    const em = emailEl.value.trim();
    if (em && !EMAIL_RE.test(em)) { err('email'); ok = false; }
    if (!cfg.siteKey) { err('form', MESSAGES.unavailable); ok = false; }
    else if (!captchaToken) { err('captcha'); ok = false; }
    if (!ok) { const first = root.querySelector('.tbr-error:not([hidden])'); first && first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    return ok;
  }
  function setBusy(on, label) { busy = on; submitBtn.disabled = on; submitLabel.textContent = on ? label : 'Submit review'; }
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (busy || !validate()) return;
    let uploadToken = null;
    let resourceUrl = null;
    if (file) {
      setBusy(true, 'Uploading photo…');
      const up = await uploadPhoto(file);
      if (!up.ok) { setBusy(false); err('photo', MESSAGES[up.error] || MESSAGES.upload_failed); return; }
      uploadToken = up.uploadToken;
      resourceUrl = up.resourceUrl;
    }
    setBusy(true, 'Submitting…');
    const sizeEl = form.querySelector('input[name="size"]:checked');
    const email = emailEl.value.trim();
    const res = await api('submit', {
      productId: cfg.productId,
      rating,
      body: bodyEl.value,
      name: nameEl.value,
      email: email || null,
      size: sizeEl ? sizeEl.value : null,
      uploadToken,
      resourceUrl,
      turnstileToken: captchaToken,
      hp: (root.querySelector('[data-tbr-hp]') || {}).value || '',
      orderId: linkOrder,
      openedAt,
    });
    setBusy(false);
    if (res.ok) {
      $('[data-tbr-done-badge]').hidden = res.verified !== true;
      const rw = $('[data-tbr-reward]'), code = res.reward || (rw && rw.dataset.default) || '';
      if (rw) { rw.hidden = !code; $('[data-tbr-reward-code]').textContent = code; }
      form.hidden = true; done.hidden = false; done.focus();
      modal.querySelector('.tbr-modal__panel').scrollTop = 0;
      resetPhoto(); resetCaptcha();
      return;
    }
    resetCaptcha();
    if (res.error === 'invalid' && Array.isArray(res.fields)) {
      res.fields.forEach((f) => err(f === 'product' ? 'form' : f));
      err('form', MESSAGES.invalid);
    } else if (/^photo_/.test(res.error || '')) {
      err('photo', MESSAGES[res.error]);
    } else {
      err('form', MESSAGES[res.error] || MESSAGES.unavailable);
    }
  });

  /* ---------- reward copy ---------- */
  const copyBtn = $('[data-tbr-copy]');
  if (copyBtn) copyBtn.addEventListener('click', async () => {
    const code = $('[data-tbr-reward-code]').textContent.trim();
    let ok = false;
    try { await navigator.clipboard.writeText(code); ok = true; } catch (_) {
      const r = document.createRange(); r.selectNodeContents($('[data-tbr-reward-code]'));
      const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
    }
    copyBtn.textContent = ok ? 'Copied ✓' : 'Select & copy';
    setTimeout(() => { copyBtn.textContent = 'Copy code'; }, 2200);
  });

  /* ---------- open from review email ---------- */
  if (wantsReview && !window.__tbrDeepLinked) {
    window.__tbrDeepLinked = true;
    const go = () => setTimeout(() => { root.scrollIntoView({ block: 'start' }); open(); }, 350);
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
}
document.querySelectorAll('[data-tbr-pdp]').forEach(tbrInit);
document.addEventListener('shopify:section:load', (e) => { const r = e.target.querySelector('[data-tbr-pdp]'); if (r) tbrInit(r); });
})();